import {GraphApiHits, OrganizationUser} from "../../model/api"

export const filterGraphApiPeopleHits = (hits: GraphApiHits) => {
    return hits.filter(hit => hit.resource.personType?.class === "Person" && hit.resource.personType?.subclass === "OrganizationUser") as OrganizationUser[]
}